import { Accordion, Flex, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import type { CoverLimitProps } from "../../CoverLimit";
import { CoverLimit } from "../../CoverLimit";

export type DeductiblesProps = {
  excesses: CoverLimitProps[];
  excessTitle: string;
  coverName: string;
  variant: "qds" | "qcp";
};

export const Deductibles = ({
  excesses,
  excessTitle,
  coverName,
  variant,
}: DeductiblesProps) => {
  const { snowplow } = useSnowplowContext();
  const hasExcesses = excesses.length > 0;
  if (excessTitle === "Deductible") {
    excessTitle += "s";
  }

  if (variant === "qcp") {
    return (
      hasExcesses && (
        <Accordion
          showText={excessTitle}
          hideText={excessTitle}
          onOpen={() => snowplow?.trigger("deductiblesClicked")}
          headerPosition="top"
        >
          {excesses.map(cover => (
            <CoverLimit key={cover.title} {...cover} product={coverName} />
          ))}
        </Accordion>
      )
    );
  }

  return (
    hasExcesses && (
      <Flex className="mobius-quote-card__deductibles" flexDirection="column">
        <Text className="mobius-quote-card__deductibles-title">
          {excessTitle}
        </Text>
        {excesses.map(cover => (
          <CoverLimit key={cover.title} {...cover} product={coverName} />
        ))}
      </Flex>
    )
  );
};
